const Mandatory = () => {
    return <span style={{ color: "red" }}>*</span>;
}

export default Mandatory;
